<template>
  <div id="app">
    <header>
      <div class="logo-container">
        <img src="./assets/logo.png" alt="67WHALE CTO Logo" class="logo">
        <h1 class="brand-name">67WHALE CTO</h1>
      </div>
      <nav>
        <a href="#about">About</a>
        <a href="#how-it-works">Live Chart</a>
        <a href="#faq">FAQ</a>
        <button class="connect-wallet-btn">Connect Wallet</button>
      </nav>
    </header>

    <section class="hero">
      <div class="official-badge">
        <span class="badge-icon">✓</span> Official token
      </div>
      <br>
      
      <div class="hero-content">
        <h1 class="main-title">Discover Exclusive</h1>
        <h2 class="sub-title">$67WHALE Token</h2>
        <p class="description">Join the 67WHALE revolution on Solana blockchain. Trade, participate, and be part of the top blockchain project across Solana ecosystem. Don't miss out!</p>
        <div class="cta-buttons">
          <a href="#live-chart" class="cta-button primary">Trade Now</a>
          <a href="#about" class="cta-button secondary">Learn More</a>
        </div>
        <div class="token-address">
          <p class="address-label">Token Address (CA):</p>
          <div class="address-box">
            <code>2TSC2PaXZDCkrBoxcNBiQyWh61dC9bRGqL8nKwfbpump</code>
            <button class="copy-btn" @click="copyAddress">Copy</button>
          </div>
        </div>
      </div>
      <div class="hero-image">
        <img src="./assets/logo.png" alt="Whale Coin" class="floating-whale">
        <div class="orbit-circle"></div>
        <div class="space-particles particle-1"></div>
        <div class="space-particles particle-2"></div>
        <div class="space-particles particle-3"></div>
      </div>
    </section>


    <section id="live-chart" class="live-chart-section">
      <h2 class="section-title">Live Chart</h2>
      <div class="chart-container">
        <iframe 
          id="dexscreener-embed" 
          src="https://dexscreener.com/solana/2TSC2PaXZDCkrBoxcNBiQyWh61dC9bRGqL8nKwfbpump?embed=1&theme=dark&trades=0&info=0"
          frameborder="0"
        ></iframe>
      </div>
    </section>

    <section id="live-transactions" class="live-transactions-section">
      <div class="stats-header">
        <div class="stats-logo">
          <img src="./assets/logo.png" alt="67WHALE CTO" class="stats-logo-img">
          <h3>67WHALE CTO</h3>
        </div>
        <button class="live-stats-btn">
          <span class="pulse-dot"></span>
          Live Statistics
        </button>
      </div>

      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="12" y1="1" x2="12" y2="23"></line>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
            </svg>
          </div>
          <div class="stat-content">
            <p class="stat-label">Market Cap</p>
            <p class="stat-value" id="marketCap">{{ tokenData.marketCap }}</p>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
            </svg>
          </div>
          <div class="stat-content">
            <p class="stat-label">24h Volume</p>
            <p class="stat-value" id="volume24h">{{ tokenData.volume24h }}</p>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
            </svg>
          </div>
          <div class="stat-content">
            <p class="stat-label">24h Change</p>
            <p class="stat-value" id="change24h" :class="getChangeClass()">{{ tokenData.change24h }}</p>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </div>
          <div class="stat-content">
            <p class="stat-label">Current Price</p>
            <p class="stat-value" id="currentPrice">{{ tokenData.currentPrice }}</p>
          </div>
        </div>
      </div>

      <div class="transactions-container">
        <div class="transactions-header">
          <h3>Live Transactions</h3>
          <span class="live-badge">
            <span class="live-dot"></span>
            Live
          </span>
        </div>

        <div class="transactions-list">
          <div v-for="(tx, index) in transactions" :key="index" class="transaction-item">
            <div class="transaction-col hash-col">
              <p class="col-label">HASH</p>
              <p class="col-value">{{ tx.hash }}</p>
            </div>
            <div class="transaction-col from-col">
              <p class="col-label">FROM</p>
              <p class="col-value">{{ tx.from }}</p>
            </div>
            <div class="transaction-col to-col">
              <p class="col-label">TO</p>
              <p class="col-value">{{ tx.to }}</p>
            </div>
            <div class="transaction-col amount-col">
              <p class="col-label">AMOUNT</p>
              <p class="col-value">{{ tx.amount }} 67WHALE</p>
            </div>
            <div class="transaction-col status-col">
              <span class="status-badge confirmed">✓ Confirmed</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="how-it-works" class="how-it-works">
      <div class="section-header-modern">
        <span class="section-badge">How it Works</span>
        <h2 class="section-title-modern">The 67WHALE Ecosystem</h2>
        <p class="section-description-modern">A community-driven token on Solana blockchain, designed for transparency, speed, and growth.</p>
      </div>
      
      <div class="features-modern-grid">
        <div class="feature-modern-card">
          <div class="feature-modern-icon-wrapper">
            <div class="feature-modern-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                <path d="M2 17l10 5 10-5"></path>
                <path d="M2 12l10 5 10-5"></path>
              </svg>
            </div>
          </div>
          <h3>Built on Solana</h3>
          <p>Fast transactions, low fees, and high scalability powered by Solana's cutting-edge blockchain technology.</p>
        </div>

        <div class="feature-modern-card">
          <div class="feature-modern-icon-wrapper">
            <div class="feature-modern-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
          </div>
          <h3>Community Driven</h3>
          <p>Led by passionate community members who believe in the project's vision and long-term potential.</p>
        </div>

        <div class="feature-modern-card">
          <div class="feature-modern-icon-wrapper">
            <div class="feature-modern-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
              </svg>
            </div>
          </div>
          <h3>Decentralized Trading</h3>
          <p>Trade freely on DEXs like Raydium and Jupiter with full transparency and security.</p>
        </div>

        <div class="feature-modern-card">
          <div class="feature-modern-icon-wrapper">
            <div class="feature-modern-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
            </div>
          </div>
          <h3>Real-Time Updates</h3>
          <p>Monitor live statistics, track transactions, and stay informed with real-time blockchain data.</p>
        </div>

        <div class="feature-modern-card">
          <div class="feature-modern-icon-wrapper">
            <div class="feature-modern-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
          </div>
          <h3>Secure & Transparent</h3>
          <p>All transactions are immutable and verifiable on the blockchain, ensuring complete transparency.</p>
        </div>

        <div class="feature-modern-card">
          <div class="feature-modern-icon-wrapper">
            <div class="feature-modern-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="12" y1="1" x2="12" y2="23"></line>
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
              </svg>
            </div>
          </div>
          <h3>Growth Potential</h3>
          <p>Join early in a project with strong fundamentals and a dedicated community backing its success.</p>
        </div>
      </div>
    </section>

    <section id="about" class="about">
      <h2 class="section-title">About 67WHALE</h2>
      <p class="section-description">
        67Whale is an innovative project launched by 67Mav (The67Kid) and brilliantly taken up by a dynamic community of passionate 67Whale supporters. This project continues to thrive thanks to collective commitment and an ambitious vision for the future.
      </p>
    </section>

    <section id="faq" class="faq">
      <h2 class="section-title">Frequently Asked Questions</h2>
      <div class="faq-container">
        <div class="faq-item">
          <h3>What is 67WHALE?</h3>
          <p>67WHALE is a Solana-based token that aims to bring innovation and value to the crypto community through decentralized trading and community engagement.</p>
        </div>
        <div class="faq-item">
          <h3>How do I buy 67WHALE?</h3>
          <p>Simply connect your Solana wallet (like Phantom), swap SOL for 67WHALE on decentralized exchanges, or use the contract address to trade directly.</p>
        </div>
        <div class="faq-item">
          <h3>Is it safe?</h3>
          <p>Yes, 67WHALE is built on the secure Solana blockchain. Always verify the contract address and never share your private keys with anyone.</p>
        </div>
        <div class="faq-item">
          <h3>What makes 67WHALE special?</h3>
          <p>67WHALE combines fast Solana transactions with a strong community focus, offering holders exclusive benefits and participation in project growth.</p>
        </div>
      </div>
    </section>

    <footer>
      <div class="footer-content">
        <div class="footer-logo">
          <img src="./assets/logo.png" alt="67WHALE CTO Logo" class="logo">
          <h3>67Whale CTO</h3>
        </div>
        <div class="social-links">
          <a href="https://t.me/SixSevenWhaleCTO" target="_blank" class="social-link">
            <img src="./assets/telegram-icon.svg" alt="Telegram">
          </a>
          <a href="https://twitter.com/i/communities/2010637989668356588" target="_blank" class="social-link">
            <img src="./assets/twitter-icon.svg" alt="Twitter">
          </a>
        </div>
        <p class="copyright">© 2026 The 67WHALE CTO. All rights reserved.</p>
      </div>
    </footer>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'App',
  data() {
    return {
      tokenData: {
        marketCap: 'Loading...',
        volume24h: 'Loading...',
        change24h: 'Loading...',
        currentPrice: 'Loading...'
      },
      transactions: [
        {
          hash: '4fae6cef...c6f1634a',
          from: 'FKLFqSnE...4JkZTokN',
          to: '0UuhQpr3...1tsCA44N',
          amount: '1,933,833.35',
          status: 'confirmed'
        },
        {
          hash: '5b5745ba...2b4682ae',
          from: 'Le2GHRrk...ssJBVSpj',
          to: '6yaRMo7R...akCYLU5r',
          amount: '4,122,308.49',
          status: 'confirmed'
        },
        {
          hash: '23a07c93...5474bca4',
          from: 'f8csrVGk...mq6r9CPg',
          to: 'eXhsserD...BoCbgR7Y',
          amount: '2,344,373.72',
          status: 'confirmed'
        }
      ]
    };
  },
  methods: {
    copyAddress() {
      const address = '2TSC2PaXZDCkrBoxcNBiQyWh61dC9bRGqL8nKwfbpump';
      navigator.clipboard.writeText(address).then(() => {
        alert('Token address copied to clipboard!');
      });
    },
    async fetchTokenData() {
      try {
        const response = await fetch('https://api.dexscreener.com/latest/dex/tokens/2TSC2PaXZDCkrBoxcNBiQyWh61dC9bRGqL8nKwfbpump');
        const data = await response.json();
        
        console.log('API Response:', data); // Pour debug
        
        if (data.pairs && data.pairs.length > 0) {
          const pair = data.pairs[0];
          
          console.log('Pair data:', pair); // Pour debug
          
          // Formater le market cap
          const marketCap = pair.marketCap ? this.formatNumber(pair.marketCap) : 'N/A';
          
          // Formater le volume 24h
          const volume24h = pair.volume?.h24 ? this.formatNumber(pair.volume.h24) : 'N/A';
          
          // Changement 24h
          const change24h = pair.priceChange?.h24 ? pair.priceChange.h24.toFixed(2) + '%' : 'N/A';
          
          // Prix actuel
          const currentPrice = pair.priceUsd ? '$' + parseFloat(pair.priceUsd).toFixed(8) : 'N/A';
          
          // Mettre à jour les données (Vue mettra à jour le DOM automatiquement)
          this.tokenData.marketCap = marketCap === 'N/A' ? 'N/A' : `$${marketCap}`;
          this.tokenData.volume24h = volume24h === 'N/A' ? 'N/A' : `$${volume24h}`;
          this.tokenData.change24h = change24h;
          this.tokenData.currentPrice = currentPrice;
          
          console.log('Updated tokenData:', this.tokenData); // Pour debug
        } else {
          console.warn('No pairs found in API response');
          this.tokenData = {
            marketCap: 'No data',
            volume24h: 'No data',
            change24h: 'No data',
            currentPrice: 'No data'
          };
        }
      } catch (error) {
        console.error('Error fetching token data:', error);
        this.tokenData = {
          marketCap: 'Error',
          volume24h: 'Error',
          change24h: 'Error',
          currentPrice: 'Error'
        };
      }
    },
    formatNumber(num) {
      if (num >= 1000000000) {
        return (num / 1000000000).toFixed(2) + 'B';
      } else if (num >= 1000000) {
        return (num / 1000000).toFixed(2) + 'M';
      } else if (num >= 1000) {
        return (num / 1000).toFixed(2) + 'K';
      }
      return num.toFixed(2);
    },
    getChangeClass() {
      if (!this.tokenData.change24h || this.tokenData.change24h === 'N/A' || this.tokenData.change24h === 'No data' || this.tokenData.change24h === 'Error') {
        return '';
      }
      const changeValue = parseFloat(this.tokenData.change24h);
      if (isNaN(changeValue)) return '';
      return changeValue >= 0 ? 'positive' : 'negative';
    }
  },
  mounted() {
    // Récupérer les données du token au chargement
    this.fetchTokenData();
    
    // Rafraîchir les données toutes les 30 secondes
    setInterval(() => {
      this.fetchTokenData();
    }, 30000);
    
    // Animation des éléments de la section hero
    if (document.querySelector('.main-title')) {
      gsap.from('.main-title', {
        duration: 1,
        y: 50,
        opacity: 0,
        ease: 'power3.out',
        delay: 0.3
      });
    }
    
    if (document.querySelector('.sub-title')) {
      gsap.from('.sub-title', {
        duration: 1,
        y: 50,
        opacity: 0,
        ease: 'power3.out',
        delay: 0.6
      });
    }
    
    if (document.querySelector('.description')) {
      gsap.from('.description', {
        duration: 1,
        y: 50,
        opacity: 0,
        ease: 'power3.out',
        delay: 0.9
      });
    }
    
    if (document.querySelector('.cta-buttons')) {
      gsap.from('.cta-buttons', {
        duration: 1,
        y: 50,
        opacity: 0,
        ease: 'power3.out',
        delay: 1.2
      });
    }
    
    if (document.querySelector('.token-address')) {
      gsap.from('.token-address', {
        duration: 1,
        scale: 0.8,
        opacity: 0,
        ease: 'elastic.out(1, 0.3)',
        delay: 1.5
      });
    }
    
    // Animation de la baleine flottante
    if (document.querySelector('.floating-whale')) {
      const whaleTl = gsap.timeline({
        repeat: -1,
        yoyo: true
      });
      
      whaleTl.to('.floating-whale', {
        y: 20,
        duration: 2,
        ease: 'sine.inOut'
      }).to('.floating-whale', {
        rotation: 5,
        duration: 3,
        ease: 'sine.inOut'
      }, '-=2');
    }
    
    // Animation de l'orbite
    if (document.querySelector('.orbit-circle')) {
      gsap.to('.orbit-circle', {
        rotation: 360,
        duration: 20,
        repeat: -1,
        ease: 'none'
      });
    }
    
    // Animation des particules
    if (document.querySelector('.particle-1')) {
      gsap.to('.particle-1', {
        x: 'random(-30, 30)',
        y: 'random(-30, 30)',
        duration: 'random(2, 4)',
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      });
    }
    
    if (document.querySelector('.particle-2')) {
      gsap.to('.particle-2', {
        x: 'random(-20, 20)',
        y: 'random(-20, 20)',
        duration: 'random(2, 5)',
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      });
    }
    
    if (document.querySelector('.particle-3')) {
      gsap.to('.particle-3', {
        x: 'random(-40, 40)',
        y: 'random(-40, 40)',
        duration: 'random(3, 6)',
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      });
    }
    
    // Animation du header au scroll
    if (document.querySelector('header') && document.querySelector('.hero')) {
      gsap.to('header', {
        scrollTrigger: {
          trigger: '.hero',
          start: 'bottom top',
          toggleActions: 'play none none reverse'
        },
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
        padding: '0.7rem 10%',
        duration: 0.3
      });
    }
    
    // Animations des sections désactivées
    
    // Animations au scroll des sections
    const sectionTitles = gsap.utils.toArray('.section-title');
    if (sectionTitles.length > 0) {
      sectionTitles.forEach(title => {
        gsap.from(title, {
          scrollTrigger: {
            trigger: title,
            start: 'top 80%'
          },
          duration: 0.8,
          y: 50,
          opacity: 0,
          ease: 'power3.out'
        });
      });
    }
    
    // Animations désactivées pour la section How it Works
    
    // Animation des éléments FAQ
    if (document.querySelector('.faq-item')) {
      gsap.from('.faq-item', {
        scrollTrigger: {
          trigger: '.faq-container',
          start: 'top 85%'
        },
        duration: 0.7,
        y: 50,
        opacity: 0,
        stagger: 0.15,
        ease: 'power3.out'
      });
    }

    // Animations désactivées pour éviter les erreurs de chargement
    
    // Animation du footer
    gsap.from('footer', {
      scrollTrigger: {
        trigger: 'footer',
        start: 'top 95%'
      },
      duration: 1,
      y: 50,
      opacity: 0,
      ease: 'power3.out'
    });
    
    // Effet de parallaxe sur le défilement
    window.addEventListener('scroll', () => {
      const scrollPos = window.scrollY;
      const heroSection = document.querySelector('.hero');
      const heroContent = document.querySelector('.hero-content');
      const heroImage = document.querySelector('.hero-image');
      
      if (heroSection && heroContent && heroImage && scrollPos <= heroSection.offsetHeight) {
        const translateY = scrollPos * 0.3;
        heroContent.style.transform = `translateY(${translateY}px)`;
        heroImage.style.transform = `translateY(${translateY * 0.6}px)`;
      }
    });
    
    // Animation au survol pour les éléments de fonctionnalités
    const featureCards = document.querySelectorAll('.feature-card');
    if (featureCards.length > 0) {
      featureCards.forEach(card => {
        const icon = card.querySelector('.feature-icon');
        if (icon) {
          card.addEventListener('mouseenter', () => {
            gsap.to(icon, {
              rotation: 15,
              scale: 1.1,
              duration: 0.3,
              ease: 'back.out'
            });
          });
          
          card.addEventListener('mouseleave', () => {
            gsap.to(icon, {
              rotation: 0,
              scale: 1,
              duration: 0.3,
              ease: 'back.out'
            });
          });
        }
      });
    }
    
    // Animation pour les boutons d'appel à l'action
    const ctaButtons = document.querySelectorAll('.cta-button');
    if (ctaButtons.length > 0) {
      ctaButtons.forEach(button => {
        button.addEventListener('mouseenter', () => {
          gsap.to(button, {
            y: -3,
            boxShadow: '0 10px 20px rgba(0, 0, 0, 0.2)',
            duration: 0.3
          });
        });
        
        button.addEventListener('mouseleave', () => {
          gsap.to(button, {
            y: 0,
            boxShadow: 'none',
            duration: 0.3
          });
        });
      });
    }
  }
}
</script>

<style>
:root {
  --primary-color: #00d4ff;
  --secondary-color: #0099ff;
  --dark-bg: #0a0a0a;
  --light-text: #f4f4f4;
  --card-bg: #1a1a1a;
  --accent-color: #00ffaa;
  --whale-blue: #0077cc;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Poppins', sans-serif;
  background-color: var(--dark-bg);
  color: var(--light-text);
  line-height: 1.6;
  overflow-x: hidden;
}

#app {
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  position: relative;
}

header {
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 10%;
  background-color: rgba(18, 18, 18, 0.95);
  backdrop-filter: blur(10px);
  z-index: 9999;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo {
  width: 40px;
  margin-right: 10px;
}

.brand-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary-color);
}

nav {
  display: flex;
  gap: 1.5rem;
}

nav a {
  color: var(--light-text);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;
}

nav a:hover {
  color: var(--primary-color);
}

.connect-wallet-btn {
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  color: #fff;
  padding: 0.7rem 1.5rem;
  border-radius: 30px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  font-size: 0.95rem;
}

.connect-wallet-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 212, 255, 0.3);
}

section {
  padding: 5rem 10%;
}

.official-badge {
  position: absolute;
  top: 49px;
  left: 10%;
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid var(--primary-color);
  padding: 0.5rem 1.5rem;
  border-radius: 30px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  z-index: 5;
}

.badge-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: var(--primary-color);
  border-radius: 50%;
  color: #000;
  font-weight: bold;
  font-size: 0.8rem;
}

.hero {
  min-height: 85vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: radial-gradient(circle at 70% 50%, #1a1a1a 0%, var(--dark-bg) 70%);
  position: relative;
  overflow: hidden;
  perspective: 1000px;
  padding-top: 3rem;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('./assets/stars-bg.svg');
  opacity: 0.2;
  pointer-events: none;
}

.hero-content {
  width: 55%;
  position: relative;
  z-index: 2;
  max-width: 100%;
}

.hero-image {
  width: 45%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.floating-whale {
  max-width: 80%;
  z-index: 2;
  filter: drop-shadow(0 10px 15px rgba(0, 212, 255, 0.4));
  transform-origin: center center;
}

.orbit-circle {
  position: absolute;
  width: 300px;
  height: 300px;
  border: 2px dashed rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  top: calc(50% - 150px);
  left: calc(50% - 150px);
}

.space-particles {
  position: absolute;
  width: 10px;
  height: 10px;
  background: var(--primary-color);
  border-radius: 50%;
  opacity: 0.7;
  filter: blur(2px);
  box-shadow: 0 0 10px var(--primary-color);
  pointer-events: none;
}

.particle-1 {
  top: 30%;
  left: 20%;
  width: 8px;
  height: 8px;
}

.particle-2 {
  top: 60%;
  left: 70%;
  width: 12px;
  height: 12px;
  background: var(--secondary-color);
  box-shadow: 0 0 10px var(--secondary-color);
}

.particle-3 {
  top: 40%;
  left: 80%;
  width: 6px;
  height: 6px;
  background: var(--accent-color);
  box-shadow: 0 0 10px var(--accent-color);
}

.main-title {
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: var(--light-text);
}

.sub-title {
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  background: linear-gradient(90deg, var(--primary-color), var(--accent-color));
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: 800;
}

.description {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  max-width: 600px;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.cta-button {
  padding: 0.8rem 2rem;
  border-radius: 30px;
  font-weight: 600;
  text-decoration: none;
  transition: transform 0.3s, box-shadow 0.3s, background-color 0.3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.cta-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(255,255,255,0.1), rgba(255,255,255,0.3));
  transform: translateX(-100%);
  transition: transform 0.3s;
  z-index: -1;
}

.cta-button::after {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
  border-radius: 30px;
  z-index: -2;
  opacity: 0;
  transition: opacity 0.3s;
}

.cta-button:hover::before {
  transform: translateX(0);
}

.cta-button:hover::after {
  opacity: 1;
}

.primary {
  background-color: var(--primary-color);
  color: #000;
}

.primary:hover {
  background-color: #ffce3a;
}

.secondary {
  background-color: transparent;
  border: 2px solid var(--primary-color);
  color: var(--primary-color);
}

.secondary:hover {
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.token-address {
  margin-top: 2rem;
  background: rgba(0, 212, 255, 0.05);
  padding: 1.5rem;
  border-radius: 15px;
  border: 1px solid rgba(0, 212, 255, 0.2);
}

.address-label {
  font-size: 0.9rem;
  color: var(--primary-color);
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.address-box {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: var(--card-bg);
  padding: 1rem;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.address-box code {
  flex: 1;
  color: var(--light-text);
  font-size: 0.85rem;
  word-break: break-all;
  font-family: 'Courier New', monospace;
}

.copy-btn {
  background: var(--primary-color);
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.3s, background 0.3s;
  font-size: 1.2rem;
}

.copy-btn:hover {
  transform: scale(1.1);
  background: var(--secondary-color);
}


.section-title {
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
}

.live-chart-section {
  background-color: var(--card-bg);
  padding: 5rem 10%;
}

.chart-container {
  max-width: 1200px;
  margin: 0 auto;
  height: 600px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.2);
}

.chart-container iframe {
  width: 100%;
  height: 100%;
}

.live-transactions-section {
  background-color: var(--dark-bg);
  padding: 5rem 10%;
}

.stats-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3rem;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.stats-logo {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.stats-logo-img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 3px solid var(--primary-color);
  padding: 5px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.3);
}

.stats-logo h3 {
  font-size: 1.5rem;
  color: var(--light-text);
  font-weight: 700;
}

.live-stats-btn {
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid var(--primary-color);
  color: var(--light-text);
  padding: 0.8rem 1.5rem;
  border-radius: 30px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s;
}

.live-stats-btn:hover {
  background: rgba(0, 212, 255, 0.2);
  transform: translateY(-2px);
}

.pulse-dot {
  width: 10px;
  height: 10px;
  background: var(--primary-color);
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.stat-card {
  background: var(--card-bg);
  padding: 1.5rem;
  border-radius: 15px;
  border: 1px solid rgba(0, 212, 255, 0.1);
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.3s;
}

.stat-card:hover {
  transform: translateY(-5px);
  border-color: var(--primary-color);
  box-shadow: 0 10px 30px rgba(0, 212, 255, 0.2);
}

.stat-icon {
  width: 50px;
  height: 50px;
  background: rgba(0, 212, 255, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-color);
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 0.3rem;
}

.stat-value {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--light-text);
}

.stat-value.negative {
  color: #ff4757;
}

.stat-value.positive {
  color: #00ffaa;
}

.transactions-container {
  background: var(--card-bg);
  border-radius: 20px;
  padding: 2rem;
  border: 1px solid rgba(0, 212, 255, 0.1);
}

.transactions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.transactions-header h3 {
  font-size: 1.5rem;
  color: var(--light-text);
}

.live-badge {
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid var(--primary-color);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: var(--light-text);
}

.live-dot {
  width: 8px;
  height: 8px;
  background: var(--primary-color);
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.transactions-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.transaction-item {
  background: rgba(0, 212, 255, 0.03);
  padding: 1.5rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr 1.3fr 0.8fr;
  gap: 1.5rem;
  align-items: center;
  transition: all 0.3s;
}

.transaction-item:hover {
  background: rgba(0, 212, 255, 0.08);
  border-color: var(--primary-color);
}

.transaction-col {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.col-label {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.col-value {
  font-size: 0.9rem;
  color: var(--light-text);
  font-family: 'Courier New', monospace;
  word-break: break-all;
}

.amount-col .col-value {
  color: var(--primary-color);
  font-weight: 600;
}

.status-col {
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-badge {
  background: rgba(0, 255, 170, 0.1);
  border: 1px solid var(--accent-color);
  color: var(--accent-color);
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.status-badge.confirmed {
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.partners {
  background-color: var(--dark-bg);
  padding: 3rem 10%;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.partner-logos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  flex-wrap: wrap;
  opacity: 0.6;
}

.partner-logo {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--light-text);
  letter-spacing: 1px;
  transition: opacity 0.3s, transform 0.3s;
}

.partner-logo:hover {
  opacity: 1;
  transform: scale(1.1);
}

.how-it-works {
  background-color: var(--dark-bg);
  position: relative;
  overflow: hidden;
}

.how-it-works::before {
  content: '';
  position: absolute;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(0, 212, 255, 0.05) 0%, transparent 70%);
  border-radius: 50%;
  top: -250px;
  right: -250px;
  pointer-events: none;
}

.section-header-modern {
  text-align: center;
  margin-bottom: 4rem;
}

.section-badge {
  display: inline-block;
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
  padding: 0.5rem 1.5rem;
  border-radius: 30px;
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
}

.section-title-modern {
  font-size: 2.8rem;
  font-weight: 800;
  color: var(--light-text);
  margin-bottom: 1rem;
}

.section-description-modern {
  max-width: 700px;
  margin: 0 auto;
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.8;
}

.features-modern-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-modern-card {
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.05) 0%, rgba(0, 212, 255, 0.02) 100%);
  padding: 2.5rem 2rem;
  border-radius: 20px;
  border: 1px solid rgba(0, 212, 255, 0.1);
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

.feature-modern-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
}

.feature-modern-card:hover::before {
  transform: scaleX(1);
}

.feature-modern-card:hover {
  transform: translateY(-8px);
  border-color: var(--primary-color);
  box-shadow: 0 20px 40px rgba(0, 212, 255, 0.15);
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.08) 0%, rgba(0, 212, 255, 0.04) 100%);
}

.feature-modern-icon-wrapper {
  margin-bottom: 1.5rem;
}

.feature-modern-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, rgba(0, 212, 255, 0.2) 0%, rgba(0, 153, 255, 0.1) 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-color);
  transition: all 0.4s ease;
  position: relative;
}

.feature-modern-icon::after {
  content: '';
  position: absolute;
  inset: -2px;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  border-radius: 16px;
  opacity: 0;
  z-index: -1;
  transition: opacity 0.4s ease;
}

.feature-modern-card:hover .feature-modern-icon {
  transform: scale(1.1) rotate(5deg);
}

.feature-modern-card:hover .feature-modern-icon::after {
  opacity: 0.3;
}

.feature-modern-card h3 {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--light-text);
  margin-bottom: 1rem;
  line-height: 1.4;
}

.feature-modern-card p {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.7;
}

.section-subtitle {
  max-width: 900px;
  margin: 0 auto 3rem;
  text-align: center;
  font-size: 1rem;
  opacity: 0.8;
  line-height: 1.8;
}

.watch-live {
  text-align: center;
  margin-top: 3rem;
}

.watch-live-btn {
  background: transparent;
  border: 2px solid var(--primary-color);
  color: var(--primary-color);
  padding: 1rem 3rem;
  border-radius: 30px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s;
  text-decoration: none;
  display: inline-block;
}

.watch-live-btn:hover {
  background: var(--primary-color);
  color: #000;
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 212, 255, 0.3);
}

.about {
  background-color: var(--card-bg);
}

.section-description {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  font-size: 1.2rem;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
  position: relative;
}

.feature-grid::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, 
    rgba(255, 193, 7, 0) 0%, 
    rgba(255, 193, 7, 0.3) 50%, 
    rgba(255, 193, 7, 0) 100%
  );
  z-index: 1;
}

.feature-grid::after {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  width: 1px;
  height: 100%;
  background: linear-gradient(180deg, 
    rgba(255, 193, 7, 0) 0%, 
    rgba(255, 193, 7, 0.3) 50%, 
    rgba(255, 193, 7, 0) 100%
  );
  z-index: 1;
}

.feature-card {
  background-color: var(--card-bg);
  padding: 2rem;
  border-radius: 15px;
  text-align: center;
  transition: transform 0.3s, box-shadow 0.3s;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(52, 152, 219, 0.1) 100%);
  opacity: 0;
  transition: opacity 0.3s;
  z-index: -1;
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 30px rgba(0, 0, 0, 0.2);
}

.feature-card:hover::before {
  opacity: 1;
}

.feature-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  display: inline-block;
  padding: 1rem;
  background-color: rgba(255, 193, 7, 0.1);
  border-radius: 50%;
  transition: transform 0.3s;
}

.feature-card:hover .feature-icon {
  transform: scale(1.1) rotate(10deg);
}


.faq {
  background-color: var(--card-bg);
}

.faq-container {
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.faq-item {
  background-color: var(--dark-bg);
  padding: 2rem;
  border-radius: 15px;
  border: 1px solid rgba(0, 212, 255, 0.1);
  transition: transform 0.3s, box-shadow 0.3s, border-color 0.3s;
}

.faq-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 212, 255, 0.2);
  border-color: var(--primary-color);
}

.faq-item h3 {
  color: var(--primary-color);
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.faq-item p {
  color: var(--light-text);
  opacity: 0.9;
  line-height: 1.7;
}

footer {
  background-color: var(--dark-bg);
  padding: 3rem 10%;
  text-align: center;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-link img {
  width: 30px;
  transition: transform 0.3s;
  filter: drop-shadow(0 5px 10px rgba(0, 0, 0, 0.3));
}

.social-link:hover img {
  transform: scale(1.2) rotate(10deg);
}

.copyright {
  margin-top: 1rem;
  opacity: 0.7;
}

@media (max-width: 992px) {
  section {
    padding: 3rem 5%;
  }

  .hero {
    flex-direction: column;
    text-align: center;
    min-height: auto;
    padding: 2rem 5% 3rem;
  }
  
  .hero-content, .hero-image {
    width: 100%;
  }
  
  .hero-content {
    margin-bottom: 3rem;
  }
  
  .description {
    margin: 0 auto 2rem;
  }
  
  .cta-buttons {
    justify-content: center;
    flex-direction: column;
  }

  .cta-button {
    width: 100%;
    text-align: center;
  }
  
  .partner-logos {
    gap: 1.5rem;
  }
  
  .official-badge {
    position: relative;
    left: auto;
    transform: none;
    top: auto;
    margin-bottom: 2rem;
    display: inline-flex;
  }

  .feature-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  header {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 5%;
  }
  
  nav {
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.8rem;
  }

  nav a {
    font-size: 0.9rem;
  }

  .connect-wallet-btn {
    width: 100%;
    justify-content: center;
  }

  .logo {
    width: 35px;
  }

  .brand-name {
    font-size: 1.2rem;
  }
  
  .main-title {
    font-size: 1.8rem;
  }
  
  .sub-title {
    font-size: 2rem;
  }

  .description {
    font-size: 1rem;
  }

  .hero-image {
    max-width: 300px;
    margin: 0 auto;
  }

  .floating-whale {
    max-width: 100%;
  }
  
  .chart-container {
    height: 400px;
    border-radius: 15px;
  }

  .live-chart-section {
    padding: 3rem 5%;
  }
  
  .address-box {
    flex-direction: column;
    gap: 0.8rem;
  }

  .address-box code {
    font-size: 0.75rem;
    text-align: center;
  }

  .copy-btn {
    width: 100%;
  }

  .token-address {
    padding: 1rem;
  }

  .stats-header {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .stats-logo {
    flex-direction: column;
  }

  .stats-logo-img {
    width: 50px;
    height: 50px;
  }

  .stats-logo h3 {
    font-size: 1.2rem;
  }

  .live-stats-btn {
    padding: 0.6rem 1.2rem;
    font-size: 0.85rem;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stat-card {
    padding: 1.2rem;
  }

  .stat-icon {
    width: 45px;
    height: 45px;
  }

  .stat-value {
    font-size: 1.2rem;
  }

  .transactions-container {
    padding: 1.5rem;
    border-radius: 15px;
  }

  .transactions-header {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }

  .transactions-header h3 {
    font-size: 1.2rem;
  }

  .transaction-item {
    grid-template-columns: 1fr;
    gap: 0.8rem;
    padding: 1rem;
  }

  .col-label {
    font-size: 0.7rem;
  }

  .col-value {
    font-size: 0.85rem;
  }

  .status-badge {
    padding: 0.4rem 0.8rem;
    font-size: 0.8rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .section-subtitle {
    font-size: 0.95rem;
  }

  .faq-item {
    padding: 1.5rem;
  }

  .faq-item h3 {
    font-size: 1.1rem;
  }

  .partner-logo {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .main-title {
    font-size: 1.5rem;
  }

  .sub-title {
    font-size: 1.8rem;
  }

  .chart-container {
    height: 350px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stat-card {
    flex-direction: row;
    gap: 1rem;
  }

  .section-title {
    font-size: 1.8rem;
  }

  .official-badge {
    font-size: 0.85rem;
    padding: 0.4rem 1.2rem;
  }

  .address-box code {
    font-size: 0.7rem;
  }

  .partner-logos {
    gap: 1rem;
  }

  .partner-logo {
    font-size: 0.9rem;
  }

  .watch-live-btn {
    padding: 0.8rem 2rem;
    font-size: 0.9rem;
    width: 100%;
    max-width: 300px;
  }

  .feature-card {
    padding: 1.5rem;
  }

  .feature-icon {
    font-size: 2.5rem;
  }

  .section-title-modern {
    font-size: 1.8rem;
  }

  .section-description-modern {
    font-size: 0.95rem;
  }

  .features-modern-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .feature-modern-card {
    padding: 2rem 1.5rem;
  }

  .feature-modern-icon {
    width: 60px;
    height: 60px;
  }

  .feature-modern-card h3 {
    font-size: 1.2rem;
  }

  .feature-modern-card p {
    font-size: 0.9rem;
  }
}

/* Ajout de l'effet de parallaxe pour les arrière-plans */
@media (min-width: 992px) {
  .hero::before {
    animation: floating-stars 100s linear infinite;
  }
  
  @keyframes floating-stars {
    0% { background-position: 0 0; }
    100% { background-position: 500px 500px; }
  }
}

/* Sections visibles par défaut - animations désactivées */
.live-chart-section, .live-transactions-section, .about, .how-it-works, .faq {
  opacity: 1;
  transform: translateY(0);
}

/* Nouveaux styles pour la grille de fonctionnalités */
.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
  position: relative;
}

.feature-grid::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, 
    rgba(255, 193, 7, 0) 0%, 
    rgba(255, 193, 7, 0.3) 50%, 
    rgba(255, 193, 7, 0) 100%
  );
  z-index: 1;
}

.feature-grid::after {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  width: 1px;
  height: 100%;
  background: linear-gradient(180deg, 
    rgba(255, 193, 7, 0) 0%, 
    rgba(255, 193, 7, 0.3) 50%, 
    rgba(255, 193, 7, 0) 100%
  );
  z-index: 1;
}

/* Style amélioré pour les tokénomics */
.tokenomics-container {
  display: flex;
  flex-direction: column;
  gap: 3rem;
  position: relative;
}

.tokenomics-container::before {
  content: '';
  position: absolute;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, var(--primary-color) 0%, transparent 70%);
  opacity: 0.1;
  border-radius: 50%;
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.tokenomics-container::after {
  content: '';
  position: absolute;
  width: 150px;
  height: 150px;
  background: radial-gradient(circle, var(--secondary-color) 0%, transparent 70%);
  opacity: 0.1;
  border-radius: 50%;
  bottom: 0;
  right: 0;
  transform: translate(50%, 50%);
  z-index: 0;
}

/* Effet de survol pour les boutons */
.cta-button {
  padding: 0.8rem 2rem;
  border-radius: 30px;
  font-weight: 600;
  text-decoration: none;
  transition: transform 0.3s, box-shadow 0.3s, background-color 0.3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.cta-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(255,255,255,0.1), rgba(255,255,255,0.3));
  transform: translateX(-100%);
  transition: transform 0.3s;
  z-index: -1;
}

.cta-button::after {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
  border-radius: 30px;
  z-index: -2;
  opacity: 0;
  transition: opacity 0.3s;
}

.cta-button:hover::before {
  transform: translateX(0);
}

.cta-button:hover::after {
  opacity: 1;
}
</style>
